import { Icon } from '@chakra-ui/react';

export const Protection = (props) => (
  <Icon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M20 11.1818C20 15.7228 16.587 19.9688 12 20.9998C7.413 19.9688 4 15.7228 4 11.1818V7.61482C4 6.80282 4.491 6.07082 5.243 5.76382L10.243 3.71782C11.369 3.25682 12.631 3.25682 13.757 3.71782L18.757 5.76382C19.509 6.07182 20 6.80282 20 7.61482V11.1818V11.1818Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.25 10.125L11.5 13.875L9.25 11.625"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
